export default __webpack_public_path__ + "static/media/sticks.b2846246.mp3";